// UTILS
import { formatValue } from '../../../scripts/formatValue';

// STYLES
import { useAppRouter } from '../../../hooks/useAppRouter';
import styles from '../css/menu.module.css';

// ASSETS
const no_image_vector = require('../../../assets/marca-dagua-sofchef.png');




export const RenderLastOrderedProducts = ({item, index, companyData}) => {
    
    const navigate = useAppRouter();
    
    // FORMAT PRICE VALUES ==========>
    const price = formatValue(item.price);
    const promotionPrice = item.promotion && item.promotion_price ? formatValue(item.promotion_price) : null;

    return (
        <button className={styles.comboComponent} onClick={() => {
            if (!companyData.status || !item.active) {
                return;
            }
            
            navigate(`product/${item.id}`);
        }}>

            <div className={styles.imgComboMenu} style={{ backgroundImage: item.image ? `url(${item.image})` : `url(${no_image_vector})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />

            <div className={styles.informationsComboArea}>
                <div className={styles.comboContainer}>
                    <p className={styles.textProducts} id={item.name} style={{ whiteSpace: 'wrap' }}>{item.name}</p>

                    {item.description && <p className={styles.textProducts} id={styles.productDescription} style={{ color: '#555' }}>{item.description}</p>}

                    <p className={styles.textProducts} id={styles.productPrice}>A partir de {price}</p>

                    {item.end_date && <p className={styles.textProducts} id={styles.productDescription} style={{ marginTop: 10 }}>Expira em: {item.end_date}</p>}

                </div>
            </div>
        </button>
    )
}